function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "help",
  transform: "translate(0 0)"
}, React.createElement("g", {
  id: "Group_2223",
  "data-name": "Group 2223"
}, React.createElement("g", {
  id: "Group_2220",
  "data-name": "Group 2220"
}, React.createElement("path", {
  id: "Path_3343",
  "data-name": "Path 3343",
  d: "M9.5,19A9.5,9.5,0,1,1,19,9.5,9.511,9.511,0,0,1,9.5,19Zm0-17.469A7.969,7.969,0,1,0,17.469,9.5,7.978,7.978,0,0,0,9.5,1.531Z",
  fill: "#fff"
})), React.createElement("g", {
  id: "Group_2222",
  "data-name": "Group 2222",
  transform: "translate(7.199 6.081)"
}, React.createElement("g", {
  id: "Group_2221",
  "data-name": "Group 2221"
}, React.createElement("path", {
  id: "Path_3344",
  "data-name": "Path 3344",
  d: "M113.926,96.8a2.2,2.2,0,0,1,.458-.729,2.048,2.048,0,0,1,.712-.482,2.388,2.388,0,0,1,.931-.174,2.926,2.926,0,0,1,1.109.183,2.167,2.167,0,0,1,.716.454,1.647,1.647,0,0,1,.388.584,1.692,1.692,0,0,1,.117.585,2,2,0,0,1-.117.739,1.821,1.821,0,0,1-.29.5,1.931,1.931,0,0,1-.384.351q-.21.145-.4.29a1.851,1.851,0,0,0-.332.332.947.947,0,0,0-.182.467v.356H115.39v-.421a1.916,1.916,0,0,1,.154-.673,1.946,1.946,0,0,1,.295-.463,2.375,2.375,0,0,1,.356-.332q.187-.141.346-.28a1.284,1.284,0,0,0,.257-.309.768.768,0,0,0,.089-.421.853.853,0,0,0-.211-.636.8.8,0,0,0-.585-.206.907.907,0,0,0-.435.1.87.87,0,0,0-.3.262,1.139,1.139,0,0,0-.173.383,1.905,1.905,0,0,0-.056.473h-1.375A2.662,2.662,0,0,1,113.926,96.8Zm2.8,4.014v1.44h-1.469v-1.44Z",
  transform: "translate(-113.753 -95.416)",
  fill: "#fff"
})))));
var SvgHelp = function SvgHelp(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), _ref2);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHelp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help.dc637330.svg";
export { ForwardRef as ReactComponent };